module.exports = __webpack_public_path__ + "static/media/amazonpayLight.ce4e7c76.svg";